import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-trial-template',
  standalone: true,
  templateUrl: './trial-template.component.html'
})
export class TrialTemplateComponent {
  @Input() title = 'Teste grátis de 7 dias. Sem compromisso.';
  @Input() description = 'Conheça a Casato Brasil, explore imóveis, ative alertas e veja como encontrar oportunidades melhores.';
  @Input() buttonLabel = 'Começar teste grátis';
  @Output() ctaSelected = new EventEmitter<void>();

  onSelect(): void {
    this.ctaSelected.emit();
  }
}
